import config from '../config';

export const getLocaleFromPath = (path) => {
  const match = path.match(/^\/([a-z]{2})\//);
  return (match && match[1]) || config.locale;
};
